// extracted by mini-css-extract-plugin
module.exports = {"description":"Aside_description__1i8dq","buttonRow":"Aside_buttonRow__1FMcv","aside":"Aside_aside__IZSYl","col":"Aside_col__2u0hb"};